import { FC } from "react";

import { PageContextWrapper, ReportsContextWrapper } from "@ryde/controls";

import { ReportsPageContent } from "./reports.page.content";

export const ReportsPage: FC = () => {
  return (
    <PageContextWrapper entity="report">
      <ReportsContextWrapper>
        <ReportsPageContent />
      </ReportsContextWrapper>
    </PageContextWrapper>
  );
};
